// @mui
import { GridAggregationFunction } from '@mui/x-data-grid-premium';

export const Attendance: GridAggregationFunction<boolean, number> = {
  label: 'Attendance',
  apply: ({ values }) => {
    if (values === null) {
      return null;
    }
    let totalMembers = 0;
    values.forEach((x) => {
      if (x !== undefined && x !== null) {
        if (x === true) {
          totalMembers += 1;
        }
      }
    });
    return totalMembers;
  },
  columnTypes: ['number'],
};
